import { listOfStringsTypeFiltersCombiner } from "./listOfStringsTypeFiltersCombiner";
import { RootState } from "../../../../store";
import { resourceExplorerAppliedFiltersSelector } from "../resourceExplorerAppliedFiltersSelector";

export const appliedServiceSelector = (state: RootState) => {
  const filters = resourceExplorerAppliedFiltersSelector(state);

  return listOfStringsTypeFiltersCombiner("service", filters);
};
